import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { formValueSelector, change } from 'redux-form';
import { removeNonDigitCharacters } from 'utils/helpers';
import Expenses from 'components/Credit24/LoanApplication/ExpensesAU';
import { incomeFrequency } from 'consts';

const otherExpensesFieldsDescriptor = [
  { name: 'foodGroceriesExpenses' },
  { name: 'transportExpenses' },
  { name: 'healthMedicalExpenses' },
  { name: 'insuranceExpenses' },
  { name: 'utilitiesExpenses' },
  { name: 'phoneInternetExpenses' },
  { name: 'otherExpenses', hasHint: true },
];

const otherExpensesFieldsNames = otherExpensesFieldsDescriptor.map(field => field.name);
const selector = formValueSelector('loan');

const toNumber = (value) => {
  if (value == null) return 0;
  const n = Number(removeNonDigitCharacters(String(value)));
  return Number.isFinite(n) ? n : 0;
};

const UpgradeExpensesAUContainer = () => {
  const dispatch = useDispatch();

  const otherExpenses = useSelector(
    state => selector(state, ...otherExpensesFieldsNames),
    shallowEqual
  );

  const totalLivingExpensesRaw = useSelector(
    state => selector(state, 'totalLivingExpenses')
  );

  const nextTotal = useMemo(() => {
    if (!otherExpenses) return 0;
    return Object.values(otherExpenses).reduce((sum, value) => sum + toNumber(value), 0);
  }, [otherExpenses]);

  const currentTotal = toNumber(totalLivingExpensesRaw);

  useEffect(() => {
    if (nextTotal !== currentTotal) {
      dispatch(change('loan', 'totalLivingExpenses', String(nextTotal)));
    }
  }, [dispatch, nextTotal, currentTotal]);

  return (
    <Expenses
      incomeFrequencies={incomeFrequency}
      otherExpensesFieldsDescriptor={otherExpensesFieldsDescriptor}
      totalLivingExpenses={Number(totalLivingExpensesRaw) || 0}
    />
  );
};

export default UpgradeExpensesAUContainer;
